<template>
<div v-if="!authorized">
    <btn title="Пароль можно получить у менеджера" color="info" class="btn-sm btn-call waves-effect hoverable" @click.native="$emit('showLogin')" > Вход </btn>
</div>
<div v-else-if="authorized && !mng">
    <btn class="btn-sm btn-call hoverable z-depth-1" title="Выход" outline="black" @click.native="logoff()"><i class="fa-solid text-white fa-person-through-window fa-2x"></i></btn>
</div>
<div v-else-if="mng && !boss">
    <btn class="btn-sm btn-call hoverable z-depth-1" title="Менеджер - выйти" outline="black" color="warning" @click.native="logoff()"><i class="orange-text fa-solid fa-person-through-window fa-2x"></i></btn>
</div>
<div v-else-if="mng && boss">
    <btn class="btn-sm btn-call hoverable z-depth-1" title="Руководитель - выйти" outline="black" color="deep-orange-text" @click.native="logoff()"><i class="deep-orange-text fa-solid fa-person-through-window fa-2x"></i></btn>
</div>
</template>
<script>
import { Container, Row, Column, MdTextarea, Btn, Fa, Modal, ModalHeader, ModalBody, ModalFooter, Tooltip } from 'mdbvue'
export default {
  name: 'Login',
  components: {
    Container,
    Row,
    Column,
    MdTextarea,
    Btn,
    Fa,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Tooltip
  },
  props: ['authorized', 'mng', 'ai', 'boss'],
  methods:
    {
      logoff: function () {
        this.$localStorage.remove('Login')
        this.$localStorage.remove('Password')
        this.$emit('logoff')
        this.UID = ''
        window.location.href = '/'
        this.ai = 0
        this.$router.push('About')
        location.reload()
      }
    },
  mounted () {
  },
  data () {
    return {
      showModal: false,
      UID: ''
    }
  }
}
</script>

<style scoped>
  .btn-call {
    border-radius: 1.5rem;
    border: 5px;
  }
  .btn[class*=btn-outline-].btn-sm {
    padding-top: 0.8rem;
    padding-bottom: .38rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue